import moment from 'moment'

export const getOffset = () => {
    const date: string = moment().format()
    const offset: string = date.substr(date.length - 6)
    return `gmt=${offset}`
}